import { RectangleHorizontal, Type } from "lucide-react";
import { getIconUrl } from "@/utils/iconUtils";

interface RelationComponentProps {
  name: string;
  organizationName?: string;
  componentType?: {
    icon?: string | null;
  };
}

export function RelationComponentBox({ name, organizationName, componentType }: RelationComponentProps) {
  // Função para renderizar ícone (idêntica ao ComponentItem)
  const renderIcon = () => {
    // Ícone padrão para componentes com ícone
    if (componentType?.icon) {
      const iconUrl = getIconUrl(componentType.icon);
      return (
        <img 
          src={iconUrl || ''}
          alt=""
          className="w-5 h-5 flex-shrink-0"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      );
    }
    
    // Ícone padrão para componentes sem ícone
    return (
      <div className="w-5 h-5 flex-shrink-0 bg-sidebar-accent rounded flex items-center justify-center">
        <div className="w-2 h-2 bg-sidebar-foreground/50 rounded"></div>
      </div>
    );
  };

  return (
    <div className="flex items-center gap-3 p-3 rounded-lg border border-sidebar-border bg-sidebar min-w-0">
      {renderIcon()}
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-sidebar-foreground">
          {name}
        </div>
        <div className="text-xs text-sidebar-foreground/70">
          {organizationName || 'Sem organização'}
        </div>
      </div>
    </div>
  );
}